<!-- Tooltip shell: projects trigger and popup body. -->
<div #tooltipWrapper class="kt-tooltip-wrapper" (mouseenter)="onWrapperEnter()" (mouseleave)="onWrapperLeave()">
    <!-- Hover target -->
    <ng-content select="[tooltip-trigger]"></ng-content>

    <!-- Popup container -->
    <div #tooltipPanel class="kt-tooltip-panel" *ngIf="showPanel" [class.is-visible]="isVisible" [style.width.px]="panelWidth"
        [style.left.px]="panelLeft" [style.top.px]="panelTop">
        <!-- Popup content -->
        <ng-content select="[tooltip-body]"></ng-content>
    </div>
</div>
